<!--
 * @Author: ll
 * @Date: 2021-12-16 18:28:48
 * @LastEditTime: 2021-12-21 17:12:12
 * @LastEditors: yeqing
 * @Description: 小巨人第二步
-->
<template>
  <div>
    <div class="lit-title">
      <span class="lit-ban"></span>
      <span class="lit-txt2">创新能力测评</span>
    </div>
    <!-- 表单 -->
    <div class="lit-form">

      <div class="lit-forms">
        <span class="lit-form-tit">企业截至上年末，企业从事特定细分市场时间达到 3 年以上</span>
        <div class="lit-radios">
          <span
              class="lit-radio"
              :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
              @click="selectClick('q513', '没有')"
          >没有</span>
          <span class="lit-radio" :class="giantForm.q513 == '有' ? 'lit-active' : ''" @click="selectClick('q513', '有')" >有</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">企业主营业务收入总额占营业收入总额比重不低于 70%</span>
        <div class="lit-radios">
          <span
              class="lit-radio"
              :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
              @click="selectClick('q513', '没有')"
          >没有</span>
          <span class="lit-radio" :class="giantForm.q513 == '有' ? 'lit-active' : ''" @click="selectClick('q513', '有')" >有</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">企业近 2 年主营业务收入平均增长率不低于 5%</span>
        <div class="lit-radios">
          <span
              class="lit-radio"
              :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
              @click="selectClick('q513', '没有')"
          >没有</span>
          <span class="lit-radio" :class="giantForm.q513 == '有' ? 'lit-active' : ''" @click="selectClick('q513', '有')" >有</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">企业注重数字化、绿色化发展，在研发设计、生产制造、供应链管理等环节，至少1项核心业务采用信息系统支撑</span>
        <div class="lit-radios">
          <span
              class="lit-radio"
              :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
              @click="selectClick('q513', '没有')"
          >没有</span>
          <span class="lit-radio" :class="giantForm.q513 == '有' ? 'lit-active' : ''" @click="selectClick('q513', '有')" >有</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">企业取得相关管理体系认证，或产品通过发达国家和地区产品认证（国际标准协会行业认证）</span>
        <div class="lit-radios">
          <span
              class="lit-radio"
              :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
              @click="selectClick('q513', '没有')"
          >没有</span>
          <span class="lit-radio" :class="giantForm.q513 == '有' ? 'lit-active' : ''" @click="selectClick('q513', '有')" >有</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">企业截至上年末，企业资产负债率不高于70%</span>
        <div class="lit-radios">
          <span
              class="lit-radio"
              :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
              @click="selectClick('q513', '没有')"
          >没有</span>
          <span class="lit-radio" :class="giantForm.q513 == '有' ? 'lit-active' : ''" @click="selectClick('q513', '有')" >有</span>
        </div>
      </div>


      <div class="lit-forms">
        <span class="lit-form-tit">1、企业所在的产业或细分技术领域？</span>
        <div class="lit-selects">
          <div v-for="(select, idx) in selectOptions" :key="idx" @click="switchSelect(idx, select)">
            <span
              class="lit-select"
              :class="selectIndex === idx ? 'lit-active' : ''"
            >{{ select.label }}</span>
            <van-radio-group
              v-show="selectIndex === 0 && select.value == 1"
              v-model="radioValue"
              class="vanRadios"
            >
              <van-radio
                class="vanRadio"
                icon-size="0.28rem"
                :name="index + 1"
                v-for="(radio, index) in radoiOptions"
                :key="index"
              >{{ radio }}</van-radio>
            </van-radio-group>
            <van-radio-group
              v-show="selectIndex == 1 && select.value == 2"
              v-model="radioValue"
              class="vanRadios"
            >
              <van-radio
                class="vanRadio"
                icon-size="0.28rem"
                :name="index + 1"
                v-for="(radio, index) in radoiOptions1"
                :key="index"
              >{{ radio }}</van-radio>
            </van-radio-group>
            <van-radio-group
              v-show="selectIndex == 4 && select.value == 5"
              v-model="radioValue"
              class="vanRadios"
            >
              <van-radio
                class="vanRadio"
                icon-size="0.28rem"
                :name="index + 1"
                v-for="(radio, index) in radoiOptions2"
                :key="index"
              >{{ radio }}</van-radio>
            </van-radio-group>
          </div>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">2、是否自建或与高等院校、科研机构联合建立研发机构，设立技术研究院、企业技术中心、企业工程中心、院士专家工作站、博士后工作站等？</span>
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q522 == '是' ? 'lit-active' : ''"
            @click="selectClick('q522', '是')"
          >是</span>
          <span
            class="lit-radio"
            :class="giantForm.q522 == '否' ? 'lit-active' : ''"
            @click="selectClick('q522', '否')"
          >否</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">3、企业在研发设计、生产制造、供应链管理等环节，是否至少有1项核心业务采用信息系统？</span>
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q523 == '是' ? 'lit-active' : ''"
            @click="selectClick('q523', '是')"
          >是</span>
          <span
            class="lit-radio"
            :class="giantForm.q523 == '否' ? 'lit-active' : ''"
            @click="selectClick('q523', '否')"
          >否</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">4、企业是否拥有自主品牌？</span>
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q524 == '是' ? 'lit-active' : ''"
            @click="selectClick('q524', '是')"
          >是</span>
          <span
            class="lit-radio"
            :class="giantForm.q524 == '否' ? 'lit-active' : ''"
            @click="selectClick('q524', '否')"
          >否</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">5、企业是否取得相关管理体系认证，且产品生产执行国际、国内、行业标准或产品通过发达国家和地区产品认证？</span>
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q525 == '是' ? 'lit-active' : ''"
            @click="selectClick('q525', '是')"
          >是</span>
          <span
            class="lit-radio"
            :class="giantForm.q525 == '否' ? 'lit-active' : ''"
            @click="selectClick('q525', '否')"
          >否</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">6、企业拥有有效发明专利（含集成电路布图设计专有权）：</span>
        <van-field
          type="number"
          v-model="giantForm.q526"
          center
          clearable
          placeholder="请输入"
          @focus="onFocus"
          @blur="onBlur"
        >
          <template #button>
            <span>项</span>
          </template>
        </van-field>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">7、实用新型专利、外观设计专利、软件著作权（含集成电路布图设计专有权）：</span>
        <van-field
          type="number"
          v-model="giantForm.q527"
          center
          clearable
          placeholder="请输入"
          @focus="onFocus"
          @blur="onBlur"
        >
          <template #button>
            <span>项</span>
          </template>
        </van-field>
      </div>
    </div>
  </div>
</template>
<script>
import '../../index.less';
export default {
  data() {
    return {
      value: '',
      giantForm: {
        q521: '',
        q522: '',
        q523: '',
        q524: '',
        q525: '',
        q526: '',
        q527: ''
      },
      selectOptions: [
        { label: '“工业四基”重点领域', value: 1 },
        { label: '细分产品市场', value: 2 },
        { label: '关键基础技术和产品的产业化攻关', value: 3 },
        { label: '新一代信息技术与实体经济深度融合的创新产品', value: 4 },
        { label: '制造强国战略十大重点产业领域', value: 5 },
        { label: '其他' },
      ],
      selectIndex: '',
      radioValue: '',
      radoiOptions: [
        '核心基础零部件和元器件',
        '先进基础工艺',
        '关键基础材料',
        '产业技术基础',
      ],
      radoiOptions1: [
        '制造业核心基础零部件',
        '先进基础工艺',
        '关键基础材料'
      ],
      radoiOptions2: [
        '新一代信息技术产业',
        '高档数控机床和机器人',
        '航空航天装备',
        '海洋工程装备及高技术船舶',
        '先进轨道交通装备',
        '节能与新能源汽车',
        '电力装备',
        '农机装备',
        '新材料',
        '生物医药及高性能医疗器械'
      ],
    };
  },
  methods: {
    switchSelect(index, select) {
      this.selectIndex = index;
      if (index == 0) {
        this.giantForm.q521 = this.radoiOptions[this.radioValue - 1]
      } else if (index == 1) {
        this.giantForm.q521 = this.radoiOptions1[this.radioValue - 1]
      } else if (index == 4) {
        this.giantForm.q521 = this.radoiOptions2[this.radioValue - 1]
      } else {
        this.giantForm.q521 = select.label
      }
      console.log(this.giantForm.q521);
    },
    selectClick(type, val) {
      this.giantForm[type] = val;
    },
    onFocus() {
      this.$emit('onFocus')
    },
    onBlur() {
      this.$emit('onBlur')
    }
  },
};
</script>
<style lang="less" scoped>
.lit-selects {
  display: flex;
  flex-direction: column;
  .lit-select {
    width: 6.5rem;
    display: inline-block;
    padding: 0.15rem 0.2rem;
    text-align: left;
    background: #ffffff;
    border-radius: 0.06rem;
    border: 1px solid #e0e0e0;
    margin: 0 0.2rem 0.2rem 0;
  }
  .lit-active {
    color: #0072f7;
    border-color: #0072f7;
  }
  .vanRadios {
    width: 6.5rem;
    // height: 2.62rem;
    background: #f9f9f9;
    border-radius: 0.04rem;
    margin-bottom: 0.2rem;
    padding: 0.2rem;
    .vanRadio {
      margin-bottom: 0.2rem;
    }
  }
}
</style>
